module.exports = __webpack_public_path__ + "static/media/clipboard-prescription.8a6b492c.svg";